import React, { useState } from 'react';
import StaffMemberCard from './StaffMemberCard';

const Team = ({ staffMembers }) => {
  return (
    <section className="mb-20 md:mb-28">
      <h2 className="text-3xl font-bold tracking-tight text-center text-white sm:text-4xl mb-16">
        Meet Our Team
      </h2>
      <div className="flex flex-wrap justify-center gap-x-8 gap-y-12">
        {staffMembers.map((member) => (
          <StaffMemberCard 
            key={member.id}
            member={member}
          />
        ))}
      </div>
    </section>
  );
};

export default Team;